var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data.open
    ? _c("div", { staticClass: "info-block" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "flex flex_gap_10" }, [
              _c("div", { staticClass: "flex_child" }, [
                _c("h5", { staticClass: "mb-1" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$AllProjects[_vm.data.data.order.site_id].title
                      )
                    ),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$AllCities[_vm.data.data.order.city_id].name)
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Курьер: "),
                  _c("strong", [_vm._v(_vm._s(_vm.data.data.runner_name))]),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v(_vm._s(_vm.data.data.title))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex_child" },
                [
                  _c("p", [_vm._v("Препараты:")]),
                  _vm._v(" "),
                  _vm._l(_vm.data.data.order.drugs, function (d) {
                    return _c("h5", [_vm._v(_vm._s(d))])
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-right flex flex_gap_10" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.data.open = false
                            },
                          },
                        },
                        [_vm._v("закрыть")]
                      ),
                      _vm._v(" "),
                      _c("LoadingButton", {
                        attrs: {
                          title: "Взять в работу заявку",
                          className: "btn btn-outline-info",
                          loading: _vm.loading,
                          color: _vm.$constants.LOADING_COLOR,
                          onClick: () => _vm.openOrder(),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Запрос на звонок клиенту от курьера")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }